export default () => {
	const forms = document.querySelectorAll('.popup-adr__form');

	if (forms.length) {

		const account = document.querySelector('.account');

		let editBns = document.querySelectorAll('.js-edit-address');
		let closeBns = document.querySelectorAll('.js-close-adr');
		let VISIVBLE = 'popup-adr--visible';

		editBns.forEach(function(btn) {

			btn.addEventListener('click', (e) => {
				e.preventDefault();

				const index = btn.dataset.id;
				const popup = document.querySelector(`[data-adr="${index}"]`);

				if (popup) {
					popup.classList.add(VISIVBLE);

					account.classList.add('account--popup-opened');
				}
			});
		});

		closeBns.forEach(function(btn) {
			btn.addEventListener('click', (e) => {
				e.preventDefault();

				let popup = btn.closest('.popup-adr')
				if (popup) {
					popup.classList.remove(VISIVBLE);
					account.classList.remove('account--popup-opened');
				}
			});
		});

		let popup = document.querySelectorAll('[data-adr]');

		if (popup) {

			popup.forEach(popupItem => {
				popupItem.addEventListener('click', (e) => {
					let target = e.target;

					let popupBody = popupItem.querySelector('.popup-adr__body');
					let popupBodyTarget = target == popupBody || popupBody.contains(target);

					if (popupItem.classList.contains(VISIVBLE) && window.innerWidth > 767 && !popupBodyTarget) {
						popupItem.classList.remove(VISIVBLE);
						account.classList.remove('account--popup-opened');
					}
				});
			});
		}

		document.querySelectorAll('.js-address-delete-form').forEach(deleteForm => {
			deleteForm.addEventListener('submit', event => {
				const confirmMessage = event.target.getAttribute('data-confirm-message');

				if (!window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
					event.preventDefault();
				}
			});
		});


		const accountForm = document.querySelectorAll('.js-form-addresses');
		if (accountForm.length) {
			accountForm.forEach(form => {
				const submitBtn = form.querySelector('.js-account-form-submit');
				submitBtn.addEventListener('click', (e) => {
					const inputs = form.querySelectorAll('.js-input');

					if (inputs) {

						e.preventDefault();

						let error = false;

						inputs.forEach(input => {
							// console.log(input.querySelector('input[type="text"]'));

							if (input.querySelector('input[type="text"]').value.length > 260) {

								input.classList.add('has-error');

								const span = document.createElement('span');
								span.classList.add('input__error');
								span.innerHTML = 'A lot symbols (max 260)';
								input.appendChild(span);

								error = true;
							} else {
								if (input.classList.contains('has-error')) {
									input.classList.remove('has-error');
								}
							}
						});

						if (!error) {
							form.submit();
						}
					}
				});
			});
		}
	}


	// password recover
	if (window.location.href.includes('#recover')) {
		// console.log('password recover');
		const wrapper = document.querySelector('.register');
		if (wrapper) {
			wrapper.classList.add('register--recover');
		}
	}
}